import { CircularProgress, MenuItem, useTheme } from "@mui/material";

type ImportMenuItemProps = {
  loading?: boolean;
  disabled?: boolean;
  success?: boolean;
  onClick?: () => void;
  label?: string;
  style?: React.CSSProperties;
};

export function ImportMenuItem({ loading, disabled, onClick, label }: ImportMenuItemProps) {
  const theme = useTheme();
  return (
    <MenuItem onClick={onClick} disabled={disabled} sx={{ justifyContent: "space-between" }}>
      {label}
      <CircularProgress
        size={20}
        sx={{
          ml: theme.spacing(2),
          visibility: loading ? "visible" : "hidden",
        }}
      />
    </MenuItem>
  );
}
